import axios from "axios";
import { dev_endpont, prodcution_endpoint } from "../../endpoint";

export const URL =
  process.env.NODE_ENV === "development"
    ? `${dev_endpont}/location`
    : `${prodcution_endpoint}/location`;

export function getApi() {
  return axios.get(URL);
}

export function deleteApi(id) {
  return axios.delete(`${URL}/delete/${id}`);
}

export function detailApi(id) {
  return axios.get(`${URL}/detail/${id}`);
}

export function editApi(id, data) {
  return axios.patch(`${URL}/update/${id}`, data);
}

export function createApi(data) {
  return axios.post(`${URL}/create`, data);
}

export function getBoundry() {
  return axios.get(`${URL}/boundry`);
}

export function getLocationReportCount(name) {
  return axios.get(`${URL}/report_count?name=${name}`);
}

export function getLocationReportForGraph() {
  return axios.get(`${URL}/report`);

}

